import { useState } from 'react';
import styles from './publishVehicleModal.module.scss';
import { IoMdClose } from 'react-icons/io';
import { images } from '../../constants/images';
import ButtonShared from '../Button';

interface PublishVehicleModalProps {
    isOpen: boolean;
    onClose: () => void;
    onContinue: (vehicleType: 'new' | 'used', publicationMethod: 'manual' | 'massive') => void;
    selectedVehicleType: 'new' | 'used' | null;
    selectedPublicationMethod: 'manual' | 'massive' | null;
    setSelectedVehicleType: (vehicleType: 'new' | 'used' | null) => void;
    setSelectedPublicationMethod: (publicationMethod: 'manual' | 'massive' | null) => void;
}

const PublishVehicleModal = ({ isOpen, onClose, onContinue, selectedVehicleType, selectedPublicationMethod, setSelectedVehicleType, setSelectedPublicationMethod }: PublishVehicleModalProps) => {
    
    if (!isOpen) return null;

    const handleContinue = () => {
        if (selectedVehicleType && selectedPublicationMethod) {
            onContinue(selectedVehicleType, selectedPublicationMethod);
        }
    };

    const handleCancel = () => {
        // Use the parent's onClose which will handle the state reset
        onClose();
        setSelectedVehicleType(null);
        setSelectedPublicationMethod(null);
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContainer}>
                <button className={styles.closeButton} onClick={handleCancel}>
                    <IoMdClose />
                </button>

                <div className={styles.modalHeader}>
                    <h2>Publica tus vehículos en Linze</h2>
                </div>

                <div className={styles.modalContent}>
                    <div className={styles.sectionTitle}>
                        <p>Selecciona qué tipo de vehículos quieres publicar</p>
                    </div>

                    <div className={styles.optionsContainer}>
                        <div
                            className={`${styles.optionCard} ${selectedVehicleType === 'new' ? styles.selected : ''}`}
                            onClick={() => setSelectedVehicleType('new')}
                        >
                            <div className={styles.iconContainer}>
                                <div className={styles.vehicleIcon}>
                                    <img src={images.VerifiedIcon} alt="Manual entry" width="32" />
                                </div>
                            </div>
                            <h3>Vehículos nuevos</h3>
                            <p>Debes contar con el número VIN para publicarlo</p>
                        </div>

                        <div
                            className={`${styles.optionCard} ${selectedVehicleType === 'used' ? styles.selected : ''}`}
                            onClick={() => setSelectedVehicleType('used')}
                        >
                            <div className={styles.iconContainer}>
                                <div className={styles.vehicleIcon}>
                                    <img src={images.StabillityIcon} alt="Manual entry" width="32" />
                                </div>
                            </div>
                            <h3>Vehículos usados</h3>
                            <p>Cargas cada vehículo con su número de patente</p>
                        </div>
                    </div>

                    <div className={styles.sectionTitle}>
                        <p>Selecciona cómo los quieres publicar</p>
                    </div>

                    <div className={styles.optionsContainer}>
                        <div
                            className={`${styles.optionCard} ${selectedPublicationMethod === 'manual' ? styles.selected : ''}`}
                            onClick={() => setSelectedPublicationMethod('manual')}
                        >
                            <div className={styles.iconContainer}>
                                <img src={images.RiseIcon} alt="Manual entry" width="30" />
                            </div>
                            <h3>Carga manual</h3>
                            <p>Carga la información de un auto a la vez</p>
                        </div>

                        <div
                            className={`${styles.optionCard} ${selectedPublicationMethod === 'massive' ? styles.selected : ''}`}
                            onClick={() => setSelectedPublicationMethod('massive')}
                        >
                            <div className={styles.iconContainer}>
                                <div className={styles.methodIcon}>
                                    <img src={images.TableIcon} alt="Manual entry" width="30" />
                                </div>
                            </div>
                            <h3>Carga masiva</h3>
                            <p>Carga varios autos a través de un archivo .csv</p>
                        </div>
                    </div>
                </div>

                <div className={styles.modalFooter}>
                    <ButtonShared
                        onPress={handleCancel}
                        title="Cancelar"
                        tertiary
                        className={styles.cancelButton}
                        id="cancelPublicationButton"
                        size={"small"}
                    />
                    <ButtonShared
                        onPress={handleContinue}
                        title="Continuar"
                        primary
                        disabled={!selectedVehicleType || !selectedPublicationMethod}
                        className={styles.continueButton}
                        size={"small"}
                    />
                </div>
            </div>
        </div>
    );
};

export default PublishVehicleModal;
